// extracted by css-extract-rspack-plugin
export default {"cls1":"BulkFollowListModal-cls1_fMS","cls2":"BulkFollowListModal-cls2__xU BulkFollowListModal-cls1_fMS"};